import { Reveal } from "./Reveal";

// Owner-supplied content (Nov 2026), kept in their words.
const FACTORS = [
  ["Frequent and lengthy separations", "Extended deployments and training cycles isolate spouses and create emotional distance."],
  ["Young age at marriage", "Many service members marry between the ages of 18 and 22 before establishing long-term stability."],
  ["High-stress environments", "Post-traumatic stress disorder (PTSD), combat trauma, and demanding work hours strain relationships."],
  ["Lack of support systems", "Frequent Permanent Change of Station (PCS) moves can disrupt the civilian spouse's career and social network."],
];

export const WhyItMatters = () => (
  <section id="why" className="bg-paper text-pine py-24 md:py-32 scroll-mt-20" data-testid="why-it-matters-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1fr_1.3fr] gap-12">
      <Reveal className="min-w-0">
        <p className="lb text-brass-ink">Why military marriages matter</p>
        <h2 className="dp mt-4">The strain is real, <em>and so is hope.</em></h2>
        <div className="mt-8 rounded-2xl bg-sage p-8" data-testid="special-ops-stat">
          <p className="lb text-brass-ink">Special Operations</p>
          <p className="dp text-5xl mt-3 tn">40%–80%+</p>
          <p className="mt-3 text-moss">
            Elite units like Special Operations Forces and Navy SEAL teams face significantly higher rates, often estimated
            anecdotally or in studies to range anywhere from 40% to over 80%, due to extreme deployment tempos and operational stress.
          </p>
        </div>
      </Reveal>
      <div className="min-w-0 self-center">
        <Reveal><p className="lb text-brass-ink">Key factors driving military divorce</p></Reveal>
        <ul className="mt-4 divide-y divide-pine/15" data-testid="divorce-factors">
          {FACTORS.map(([title, text], i) => (
            <Reveal as="li" key={title} delay={i * 90} className="py-6">
              <h3 className="dp text-2xl">{title}</h3>
              <p className="mt-1 text-moss">{text}</p>
            </Reveal>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
